import { FunctionalComponent, h } from 'preact';
import { useTheme } from 'styled-components';

const OffIcon: FunctionalComponent = () => {
  const theme = useTheme();

  return (
    <svg width="100%" height="100%" viewBox="0 0 42 22" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path
          d="M0 11C0 4.925 4.92 0 11.008 0h19.984C37.072 0 42 4.924 42 11c0 6.075-4.92 11-11.008 11H11.008C4.928 22 0 17.08 0 11z"
          fill={theme.typography.color.secondary}
        />
        <path d="M11 20a9 9 0 100-18 9 9 0 000 18z" fill="white" />
        <path
          d="M29.725 11.204l3.318-3.315a.51.51 0 10-.724-.724L29 10.48l-3.319-3.315a.51.51 0 10-.724.724l3.318 3.315-3.318 3.317a.51.51 0 10.724.723L29 11.928l3.319 3.317a.509.509 0 00.724 0c.2-.2.2-.525 0-.724l-3.318-3.317z"
          fill={theme.typography.color.quaternary}
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};

export default OffIcon;
